import React from 'react';
import LegalLayout from '../components/LegalLayout';

export default function TermsPage() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="June 25, 2026" testId="terms-page">
      <p><strong>Delphi AI</strong> (&quot;Delphi&quot;, &quot;we&quot;, &quot;us&quot;) provides an AI-powered creative-media platform. By creating an account or using the Service, you agree to these Terms.</p>

      <h2>1. Eligibility</h2>
      <p>You must be at least 18 years old to use Delphi AI. By signing up, you confirm you meet this requirement and that all information you provide is accurate.</p>

      <h2>2. Account &amp; security</h2>
      <ul>
        <li>You are responsible for safeguarding your password and any activity under your account.</li>
        <li>You agree to notify us immediately of any unauthorized access.</li>
        <li>We may suspend or terminate accounts for fraud, abuse, or violations of these Terms.</li>
      </ul>

      <h2>3. Free trial &amp; subscriptions</h2>
      <p>New accounts receive a 7-day free trial (250 credits total: 200 signup bonus + 50 monthly). A payment method may be required to start the trial. Paid tiers (Standard, Pro, Creator+, Elite, Agency) renew automatically at the chosen interval until cancelled.</p>

      <h2>4. Credits</h2>
      <ul>
        <li>Generation consumes credits (per the Credit Costs schedule).</li>
        <li>Monthly tier credits reset on each billing cycle and do not roll over.</li>
        <li>Purchased credit packs do not expire and roll over indefinitely.</li>
      </ul>

      <h2>5. Acceptable use</h2>
      <p>You agree not to use Delphi AI to:</p>
      <ul>
        <li>Generate content that is illegal, defamatory, harassing, or violates third-party rights.</li>
        <li>Create non-consensual intimate imagery, child sexual abuse material, or content depicting real public figures in misleading contexts.</li>
        <li>Impersonate any person without authorization, including for fraud or deception.</li>
        <li>Train competing AI models or systematically scrape the Service.</li>
        <li>Bypass content moderation, rate limits, or watermarking.</li>
      </ul>

      <h2>6. Your content &amp; ownership</h2>
      <p>You retain ownership of the outputs you generate, subject to the limitations of the underlying AI models we partner with (Sora 2, Nano Banana, Flux Kontext, HeyGen, ElevenLabs, Suno). You grant Delphi a limited license to host, process, and display your content as necessary to operate the Service. Outputs from the free Starter tier carry a Delphi watermark.</p>

      <h2>7. AI disclaimers</h2>
      <p>AI-generated content may be inaccurate, biased, or unsuitable for certain uses. You are responsible for reviewing outputs before publishing or commercial use, and for complying with disclosure requirements in your jurisdiction.</p>

      <h2>8. Termination</h2>
      <p>You may cancel anytime from your Billing page. We may suspend or terminate accounts that violate these Terms, with or without notice. Upon termination, access to the Service ends; your data may be retained per our Privacy Policy.</p>

      <h2>9. Liability</h2>
      <p>The Service is provided &quot;as is&quot;. To the maximum extent permitted by law, Delphi&apos;s total liability to you for any claim is limited to the amount you paid us in the 12 months prior to the claim.</p>

      <h2>10. Changes</h2>
      <p>We may update these Terms; material changes will be communicated via email or in-product notice. Continued use after the effective date constitutes acceptance.</p>

      <h2>11. Contact</h2>
      <p>Questions about these Terms? Email <strong>support@delphiai.ca</strong>.</p>
    </LegalLayout>
  );
}
